<template>
  <v-card flat>
    <v-card-title class="pb-0">
      <!-- <h3 class="headline mb-0">Detalii</h3> -->
      <v-subheader>Detalii</v-subheader>
      <v-spacer></v-spacer>
      <v-btn icon flat color="blue-grey" @click.stop="_cbOpenSettings">
          <v-icon>mdi-settings</v-icon>
        </v-btn>
      <v-scale-transition>
        <v-btn icon flat color="blue-grey" v-show="isEdited" @click="_cbUndoAll">
          <v-icon>mdi-undo</v-icon>
        </v-btn>
      </v-scale-transition>
      <v-scale-transition>
        <v-btn icon flat color="blue-grey" v-show="isEdited" @click="save">
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-scale-transition>
      <!-- <v-spacer></v-spacer> -->
      <v-scale-transition>
        <v-progress-circular
          indeterminate
          size="18"
          width="2"
          color="blue-grey"
          v-show="loading">
        </v-progress-circular>
      </v-scale-transition>
      <v-btn flat icon color="blue-grey" @click="toggle">
        <v-icon>{{collapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'}}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text class="pt-0" v-if="entityObject">
      <!-- <v-divider></v-divider> -->
      <template v-for="field in fields">
        <details :key="field.value" class="my-2" :open="!collapsed" v-if="visibleFields.includes(field.value)">
          <summary :class="{'editable': isEditable(field.value)}">
            {{field.label}}

            <template v-if="isEditable(field.value) && editedFields.includes(field.value)">
              <v-btn class="ml-2" icon small @click.stop.prevent="_cbUndo(field.value)">
                <v-icon small color="blue-grey">
                  mdi-undo
                </v-icon>
              </v-btn>
            </template>

            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="field.value === 'photos'">
              <template>
                <v-icon class="ml-1" color="primary" title="Poze incarcate">mdi-camera</v-icon>
                {{entityObject[field.value].length}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0">
                  <v-icon :color="filesInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                  {{ filesInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn class="ma-0" icon flat @click.stop.prevent="_cbAddPhoto" v-if="user && !user.dummy" color="primary">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>

                <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeleteMode">
                  <v-icon :color="deleteEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDelete" v-show="deleteEnabled && toDelete.length">
                  <v-icon color="error">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deleteEnabled && toDelete.length">
                  {{toDelete.length}}
                </span>

              </template>
            </div>

            <div style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center" v-if="field.value === 'pdfs'">
              <template>
                <v-icon class="ml-1" color="primary" title="Pdf-uri incarcate">mdi-file-pdf</v-icon>
                {{entityObject[field.value].length}}
              </template>
              <template>
                <v-btn class="ma-0 ml-1 pa-0" icon flat @click.stop.prevent style="min-width: 0">
                  <v-icon :color="pdfsInQueue ? 'primary' : 'blue-grey'" class="mr-1" title="Pdf-uri in asteptare">mdi-cloud-upload</v-icon>
                  {{ pdfsInQueue }}
                </v-btn>

                <v-spacer></v-spacer>
                <v-btn class="ma-0" icon flat @click.stop.prevent="_cbAddPdf" v-if="user && !user.dummy" color="primary">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>

                <v-btn class="ma-0" icon flat @click.stop.prevent="_cbToggleDeletePdfsMode">
                  <v-icon :color="deletePdfsEnabled ? 'error' : 'blue-grey'">mdi-delete-circle</v-icon>
                </v-btn>
                <v-btn class="ma-0" icon flat @click.stop.prevent="_cbConfirmDeletePdfs" v-show="deletePdfsEnabled && toDeletePdfs.length">
                  <v-icon color="error">mdi-check-circle</v-icon>
                </v-btn>
                <span v-show="deletePdfsEnabled && toDeletePdfs.length">
                  {{toDeletePdfs.length}}
                </span>

              </template>
            </div>

            <div v-if="field.value === 'centru_geometric'" style="display: inline-flex; flex-grow: 1; flex-wrap: wrap; align-items: center">
              <v-spacer></v-spacer>
              <v-icon class="ml-1" color="primary" title="Harta">mdi-map</v-icon>
            </div>
          </summary>
          <template v-if="!['photos', 'centru_geometric', 'pdfs'].includes(field.value)">
            <div v-if="!isEditable(field.value)">{{entityObject[field.value]}}</div>
            <template v-else>
              <template v-if="field.value === 'done'">
                <v-switch v-model="entityObject.done" :label="entityObject.done ? 'Da' : 'Nu'" v-if="user && !user.dummy">
                </v-switch>
                <span v-else>{{entityObject.done}}</span>
              </template>
              <template v-else>
                <v-text-field
                  v-if="getType(field.value) !== 'textarea'"
                  :type="getType(field.value)"
                  v-model.number="entityObject[field.value]"
                  hide-details
                  single-line>
                </v-text-field>
                <v-textarea
                  v-else
                  :type="getType(field.value)"
                  v-model="entityObject[field.value]"
                  hide-details
                  single-line
                  auto-grow
                  :rows="1">
                </v-textarea>
              </template>
            </template>
          </template>

          <template v-if="field.value === 'centru_geometric'">
            <div style="width: 100%; height: 50vh">
              <GmapMap
                :center="entityObject[field.value]"
                :zoom="zoom"
                :map-type-id="mapType"
                :style="{ width: options.width, height: options.height }"
                ref="map"
                @zoom_changed="zoomChanged"
                @maptypeid_changed="mapTypeChanged">

                <GmapMarker
                  :position="entityObject[field.value]"
                  :draggable="true"
                  @position_changed="_cbPositionChanged" />

              </GmapMap>
            </div>
          </template>

          <template v-if="field.value === 'photos'">
            <viewer v-if="!deleteEnabled" :options="{url: 'data-src', backdrop: 'static'}" :key="field.value">
              <template>
                <v-layout align-center justify-flex-start wrap>
                  <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap">
                    <template v-for="(photo, pIndex) in entityObject.photos">
                      <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="photo + pIndex">
                        <v-avatar
                          size="48"
                          class="ma-1 viewerPhoto"
                          style="box-sizing: border-box">
                          <img
                            :src="serverURL + photo.replace('photos', 'thumbs')"
                            :data-src="serverURL + photo"
                            class="pa-1">
                        </v-avatar>
                        <div style="display: flex; justify-content: space-around; width: 100%">
                          <a :href="serverURL + photo + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca poza">
                            <v-icon small>mdi-download</v-icon>
                          </a>
                          <a :href="serverURL + photo + '?buster=' + new Date().getTime()" target="_blank" style="text-decoration: none" title="Deschide poza intr-un tab nou">
                            <v-icon small>mdi-eye</v-icon>
                          </a>
                        </div>
                      </div>
                    </template>
                  </v-scale-transition>
                </v-layout>
              </template>
            </viewer>
            <v-layout v-else align-center justify-flex-start wrap :key="field.value">
              <v-scale-transition group>
                <v-avatar
                  size="48"
                  v-for="(photo, pIndex) in entityObject.photos"
                  :key="photo + pIndex"
                  class="ma-1"
                  :class="{ 'deletePhoto': toDelete.includes(photo), 'normalPhoto': !toDelete.includes(photo) }"
                  style="box-sizing: border-box"
                  @click="selectPhoto(photo)">
                  <img
                    :src="serverURL + photo.replace('photos', 'thumbs')"
                    :data-src="serverURL + photo"
                    class="pa-1">
                </v-avatar>
              </v-scale-transition>
            </v-layout>
          </template>

          <template v-if="field.value === 'pdfs'">
            <template v-if="!deletePdfsEnabled">
              <v-layout align-center justify-flex-start wrap>
                <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap">
                  <template v-for="(pdf, pIndex) in entityObject.pdfs">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                      <v-avatar
                        color="primary"
                        size="48"
                        class="ma-1"
                        style="box-sizing: border-box">
                        <v-icon class="pa-1">mdi-file-pdf</v-icon>
                      </v-avatar>
                      <span class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                      <div style="display: flex; justify-content: space-around; width: 100%">
                        <a :href="serverURL + pdf + '?buster=' + new Date().getTime()" download target="_blank" style="text-decoration: none" title="Descarca pdf">
                          <v-icon small>mdi-download</v-icon>
                        </a>
                        <a @click.stop="viewPdf(pdf, serverURL + pdf + '?buster=' + new Date().getTime())" style="text-decoration: none" title="Deschide pdf">
                          <v-icon small>mdi-eye</v-icon>
                        </a>
                      </div>
                    </div>
                  </template>
                </v-scale-transition>
              </v-layout>
            </template>
            <template v-else>
              <v-layout align-center justify-flex-start wrap :key="field.value">
                <v-scale-transition group tag="div" style="display: flex; flex-wrap: wrap">
                  <template v-for="(pdf, pIndex) in entityObject.pdfs">
                    <div style="display: flex; flex-direction: column; align-items: center; width: 64px" :key="pdf + pIndex">
                      <v-avatar
                        :color="toDeletePdfs.includes(pdf) ? 'error' : ''"
                        size="48"
                        :key="pdf + pIndex"
                        class="ma-1"
                        :class="{ 'deletePdf': toDeletePdfs.includes(pdf), 'normalPdf': !toDeletePdfs.includes(pdf) }"
                        style="box-sizing: border-box"
                        @click="selectPdf(pdf)">
                        <v-icon class="pa-1">
                          mdi-file-pdf
                        </v-icon>
                      </v-avatar>
                      <span :key="pdf + pIndex + 'pdf'" class="text-no-wrap text-truncate" style="width: 64px; text-align: center" :title="pdf">{{ pdf.replace('/pdfs/', '') }}</span>
                    </div>
                  </template>
                </v-scale-transition>
              </v-layout>
            </template>
          </template>

          <v-progress-linear v-if="field.value === 'photos' && uploading.state" :value="uploading.value" height="22" color="accent">
            <span class="pl-2"> {{uploading.done}} din {{uploading.total}} ({{uploading.totalFilesDone}} din {{uploading.totalFiles}} poze)</span>
          </v-progress-linear>
          <v-divider></v-divider>
        </details>
      </template>
      <form ref="form">
        <input type="file" ref="fileinput" accept="image/*" multiple @change="filesAdded" style="display: none">
      </form>
      <form ref="pdfform">
        <input type="file" ref="pdffileinput" accept="application/pdf" multiple @change="pdfsAdded" style="display: none">
      </form>

      <v-dialog v-model="dialog" scrollable>
        <v-card>
          <v-card-title class="headline primary">
            Setari vizibilitate campuri
          </v-card-title>

          <v-card-text>
            <v-switch
              v-model="visibleFields"
              v-for="field in fields"
              :key="field.value"
              :label="field.label"
              :value="field.value">
            </v-switch>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click="_cbCloseSettings(0)">
              Renunta
            </v-btn>
            <v-btn color="primary" flat @click="_cbCloseSettings(1)">
              Salveaza
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="pdfDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="pdfDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              {{ pdfFrameTitle }}
            </v-toolbar-title>
          </v-toolbar>

          <v-card-text style="height: calc(100vh - 70px)" class="pa-0">
            <iframe :src="pdfFrameSrc" frameborder="0" width="100%" height="100%"></iframe>

            <!-- <embed :src="pdfFrameSrc" type="application/pdf" style="overflow: auto; width: 100%; height: 100%;"> -->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-card-text>
  </v-card>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer/src/component.vue'
// import { gmapApi } from 'vue2-google-maps'
import debounce from 'lodash.debounce'

export default {
  components: {
    Viewer
  },
  name: 'entity-details',
  props: {
    entity: {
      type: String,
      required: true
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('entities/setActiveEntity', to.params.entity)
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.isEdited) {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Exista modificari nesalvate! Esti sigur(a) ca vrei sa parasesti pagina?'
        }, {
          okText: 'DA',
          cancelText: 'Nu, vreau sa raman!',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.commit('entities/setActiveEntity', null)
          next()
        })
        .catch(() => {
          next(false)
        })
    } else {
      this.$store.commit('entities/setActiveEntity', null)
      next()
    }
  },
  data: () => ({
    collapsed: false,
    fields: [],
    entityObject: null,
    deleteEnabled: false,
    toDelete: [],
    uploading: {
      state: false,
      value: 0,
      done: 0,
      total: 0,
      totalFiles: 0,
      totalFilesDone: 0
    },
    options: {
      width: '100%',
      height: '100%'
    },
    dialog: false,
    visibleFields: [],
    toDeletePdfs: [],
    deletePdfsEnabled: false,
    pdfDialog: false,
    pdfFrameSrc: '',
    pdfFrameTitle: ''
  }),
  computed: {
    serverURL () {
      return this.$store.getters.serverURL
    },
    activeEntity () {
      return this.$store.getters['entities/activeEntity']
    },
    isEdited () {
      return JSON.stringify(this.activeEntity) !== JSON.stringify(this.entityObject)
    },
    editedFields () {
      return this.fields.filter(field => {
        return JSON.stringify(this.activeEntity[field.value]) !== JSON.stringify(this.entityObject[field.value])
      }).map(field => field.value)
    },
    user () {
      return this.$store.getters.user
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    filesInQueue () {
      return this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'photo').length
    },
    pdfsInQueue () {
      return this.files.filter(file => file.entity === this.activeEntity._id && !file.uploaded && file.tip === 'pdf').length
    },
    zoom () {
      return this.$store.getters.zoomDetailsPage
    },
    mapType () {
      return this.$store.getters.mapTypeDetailsPage
    },
    settings () {
      return this.$store.getters.settingsDetailsPage
    }
  },
  watch: {
    activeEntity: {
      deep: true,
      immediate: true,
      handler (obj) {
        if (obj) {
          this.entityObject = Object.assign({}, obj)

          this.fields = Object.keys(obj)
            .filter(field => {
              // console.log(field)
              // console.log(!['createdAt', 'updatedAt', '_v'].includes(field))
              return !['createdAt', 'updatedAt', '__v'].includes(field)
            })
            .sort((a, b) => compare(a, b))
            .map(field => {
              return {
                label: field.replace(/_/g, ' ').toUpperCase(),
                value: field
              }
            })
        } else {
          this.entityObject = Object.assign({})

          this.fields = []
        }
      }
    },
    settings: {
      immediate: true,
      deep: true,
      handler (val) {
        if (val) {
          if (typeof val === 'string') this.visibleFields = val.split(',')
          else if (Array.isArray(val)) this.visibleFields = val
        }
      }
    }
  },
  methods: {
    selectPhoto (photo) {
      const index = this.toDelete.findIndex(p => p === photo)
      if (index > -1) {
        this.toDelete.splice(index, 1)
      } else {
        this.toDelete.push(photo)
      }
    },
    selectPdf (pdf) {
      const index = this.toDeletePdfs.findIndex(p => p === pdf)
      if (index > -1) {
        this.toDeletePdfs.splice(index, 1)
      } else {
        this.toDeletePdfs.push(pdf)
      }
    },
    _cbAddPhoto () {
      this.$refs.fileinput.click()
    },
    _cbConfirmDelete () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva?'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePhotos', { entity: this.activeEntity._id, photos: this.toDelete })
          this.toDelete = []
        })
        .catch(() => {
        })
    },
    _cbToggleDeleteMode () {
      this.deleteEnabled = !this.deleteEnabled
      this.toDelete = []
    },
    async filesAdded (e) {
      let filesArray = Array.from(e.target.files)

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'photo' })
      this.$refs.form.reset()
    },
    async pdfsAdded (e) {
      let filesArray = Array.from(e.target.files)

      this.$store.dispatch('entities/addFiles', { files: filesArray, entity: this.activeEntity._id, tip: 'pdf' })
      this.$refs.pdfform.reset()
    },
    toggle () {
      this.collapsed = !this.collapsed
    },
    isEditable (field) {
      switch (field) {
        case 'centru_geometric':
        case 'done':
        case 'observatii_teren':
        case 'locuri_teren':
        case 'calupuri_teren': return this.user && !this.user.dummy
        default: return false
      }
    },
    getType (field) {
      switch (field) {
        case 'observatii_teren': return 'textarea'
        case 'locuri_teren': return 'number'
        case 'calupuri_teren': return 'textarea'
        default: return false
      }
    },
    save () {
      this.$store.dispatch('entities/save', this.entityObject)
    },

    zoomChanged: debounce(function ($event) {
      this.$store.commit('setZoomDetailsPage', $event)
    }, 1000),
    mapTypeChanged ($event) {
      this.$store.commit('setMapTypeDetailsPage', $event)
    },

    _cbPositionChanged: debounce(function ($event) {
      this.$set(this.entityObject, 'centru_geometric', { lat: $event.lat(), lng: $event.lng() })
    }, 1000),

    _cbUndo (fieldValue) {
      this.$set(this.entityObject, fieldValue, this.activeEntity[fieldValue])
    },

    _cbUndoAll () {
      this.editedFields.forEach(field => this._cbUndo(field))
    },

    _cbOpenSettings () {
      this.dialog = true
    },
    _cbCloseSettings (mode) {
      if (mode) {
        this.dialog = false
        this.$store.commit('setSettingsDetailsPage', this.visibleFields)
      } else {
        this.dialog = false
      }
    },

    _cbAddPdf () {
      this.$refs.pdffileinput.click()
    },
    _cbToggleDeletePdfsMode () {
      this.deletePdfsEnabled = !this.deletePdfsEnabled
      this.toDeletePdfs = []
    },
    _cbConfirmDeletePdfs () {
      this.$dialog
        .confirm({
          title: 'Atentie!',
          body: 'Aceasta operatiune este definitiva?'
        }, {
          okText: 'OK',
          cancelText: 'Mmm, ma mai gandesc',
          animation: 'zoom'
        })
        .then(dialog => {
          this.$store.dispatch('entities/deletePdfs', { entity: this.activeEntity._id, pdfs: this.toDeletePdfs })
          this.toDeletePdfs = []
        })
        .catch(() => {
        })
    },
    viewPdf (pdf, src) {
      this.pdfFrameSrc = src
      this.pdfFrameTitle = pdf.replace('/pdfs/', '')
      this.pdfDialog = true
    }
  }
}

const compare = (a, b) => {
  const fields = [
    '_id',
    'eticheta',
    'sheet',
    'simbol',
    'photos',
    'pdfs',
    'done',
    'observatii_teren',
    'locuri_teren',
    'calupuri_teren',
    'centru_geometric',
    'observatii_birou',
    'locuri',
    'carou',
    'tip',
    'poligon',
    'numar_poligoane',
    'suprafata_m2',
    'in_vecinatatea_simbolului',
    'eligibil',
    'partial_eligibil',
    'posibil_eligibil'
  ]

  return fields.findIndex(f => f === a) - fields.findIndex(f => f === b)
}

</script>

<style lang="stylus">

</style>
